export function getJumboInfo() {
  const infoMaquina = JSON.parse(localStorage.getItem("dataOpMaq"));
  const infoMina = JSON.parse(localStorage.getItem("dataOpMina"));

  return {
    idMaquina: infoMaquina?.id,
    digital: infoMaquina?.digital,
    nombreMaquina: infoMaquina?.nombre,
    nombreMina: infoMina?.nombreMina,
    idMina: infoMina?.idMina || 24,
    rutaMina: infoMina?.rutaMina,
    maquinas: infoMina?.maquinas,
    turnos: infoMina?.turnosConKey
  };
}
